{
  "device_monitor": {
    "forms": {
      "device_name": "Nombre",
      "description": "Descripción",
      "reporting_interval": "Intervalo de informes",
      "owner": "Propietario",
      "shared_to": "Compartido con",
      "model": "Modelo",
      "serial_number": "Serie",
      "power": "Energía",
      "sensors": "Sensores",
      "device_details": "Detalles",
      "hardware": "Hardware",
      "temperature": "Temperatura",
      "pressure": "Presión",
      "connectivity": "Conectividad",
      "cellular_provider": "Proveedor celular",
      "signal_strength": "Intensidad de la señal",
      "account": "Cuenta",
      "ownership": "Propiedad",
      "address": "Dirección",
      "com_type": "Tipo de comunicación",
      "com_port": "Puerto de comunicación",
      "location": "Ubicación",
      "display": "Panel público",
      "open_dashboard": "Abrir panel",
      "settings": "Configuración",
      "admin": "Administrador"
    },
    "dialogs": {
      "sensor_delete": {
        "title": "¿Está seguro?",
        "content": "¿Está seguro de que desea eliminar este sensor? No puede deshacer esta acción"
      }
    },
    "chart": {
      "data_gaps": "Huecos de datos",
      "limits": "Límites",
      "no_data": "No hay datos para mostrar",
      "no_data_select_params": "No hay datos para mostrar. Por favor seleccione parámetros."
    },
    "channel": "Canal %{id}",
    "toggle_parameters": "Alternar parámetros",
    "reload_data": "Recargar datos"
  }
}